import React, { useState, useEffect } from 'react';
import { loadData } from '../services/codeDataStore';
import LegalPageLayout from '../components/LegalPageLayout';

const PrivacyPolicy = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchPrivacyContent();
  }, []);

  const fetchPrivacyContent = async () => {
    try {
      const site = await loadData('site', {});
      if (site?.privacyPolicy) {
        setContent(site.privacyPolicy);
      } else {
        setError('Privacy Policy content not found.');
      }
    } catch (err) {
      setError('Failed to fetch privacy policy content.');
      console.error('Error fetching privacy policy content:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LegalPageLayout
      title="Privacy Policy"
      subtitle="Governs data handling, reader privacy, manuscript information, and researcher data protection."
      content={content}
      loading={loading}
      error={error}
      activePolicy="privacy"
    />
  );
};

export default PrivacyPolicy;